// extracted by mini-css-extract-plugin
export default {"rating":"kL-z","numberOfStars":"lL-z","count":"mL-z","barGraphSpacing":"nL-z","barGraph":"oL-z"};